import axios from 'axios';
import { postData } from './axiosUtils';

const menuItemService = {
  list: () => {
    return axios.get(`/api/menuItem/list`).then((response) => {
      return response.data;
    });
  },
  get: (id: any) => {
    return axios.get(`/api/menuItem/details/${id}`).then((response) => {
      return response.data;
    });
  },
  create: (entity: any) => {
    return postData({
      url: `/api/menuItem/create`,
      data: entity,
    }).then((response) => {
      return response;
    });
  },
  update: (entity: any) => {
    return postData({
      url: `/api/menuItem/update`,
      data: entity,
      method: 'PUT',
    }).then((response) => {
      return response;
    });
  },
  updateOrder: (entity: any) => {
    return postData({
      url: `/api/menuItem/updateOrder`,
      data: entity,
      method: 'PUT',
    }).then((response) => {
      return response;
    });
  },
  delete: (id: any) => {
    return postData({
      url: `/api/menuItem/delete/${id}`,
      method: 'DELETE',
    }).then((response) => {
      return response;
    });
  },
  recover: (id: any) => {
    return postData({
      url: `/api/menuItem/recover/${id}`,
      method: 'DELETE',
    }).then((response) => {
      return response;
    });
  },
  reject: (id: any) => {
    return postData({
      url: `/api/menuItem/reject/${id}`,
      method: 'DELETE',
    }).then((response) => {
      return response;
    });
  },
};

export default menuItemService;
